import {
  ATS_API_URL,
  MAIN_API_URL,
  WORKFORCE_API_URL,
  BENCHSALES_API_URL,
} from "../redux/apiConfig";
import axiosRequest from "../redux/slices/universal/axiosService";
import { getEmployeeId } from "./getEmployeeId";
import { getShortBusinessName } from "../pages/InnerPages/Employee/EmployeeProfile/Timesheets/TimesheetDetails";
import { SalaryProfileCycles } from "../assets/data/enumData";
import store from "../redux/store";
import { formatWords2 } from "./stringUtils";
import { searchPhoneNumbersInText } from "libphonenumber-js";
import { label } from "framer-motion/client";

export const dropDownGetter = async (
  type,
  limit = 5,
  search = "",
  filter = {}
) => {
  try {
    const state = store.getState();
    const orgId = state.auth?.user?.data?.organizationId.uiid;
    const filParam = filter.placementUiid?.length
      ? JSON.stringify({
          placements: {
            type: "IN",
            value: filter.placementUiid,
          },
        })
      : "";
    const masterurl = `${MAIN_API_URL}`;
    const workforceurl = `${WORKFORCE_API_URL}`;
    const benchsalesurl = `${BENCHSALES_API_URL}`;
    const atsurl = `${ATS_API_URL}`;
    const buildFilter = (value) => {
      if (!value) {
        return { type: "NONE", value: "" };
      }
      // Check for comma
      if (Array.isArray(value)&&value?.length > 1) {
        return {
          type: "IN",
          value: value
          // value: [value],
        };
      }
      // Single value
      return {
        type: "NONE",
        value: Array.isArray(value) ? value[0] : value,
      };
    };
    // const buildFilter = (value) => {
    //   if (!value) {
    //     return { type: "NONE", value: "" };
    //   }
    //   // Check for comma
    //   if (value?.length>1) {
    //     return {
    //       type: "IN",
    //       value: value
    //     };
    //   }
    //   // Single value
    //   return {
    //     type: "NONE",
    //   value: Array.isArray(value) ? value[0] : value
    //   };
    // };
    // const stateFilter = buildFilter(filter?.stateSearch);

    const stateFilter = buildFilter(filter?.stateSearch);
    const endpointMap = {
      // jobTitles: `${workforceurl}/jobtitles/getAll?coll=JobTitle&ret=title&lim=${limit}&fil={"title": {  "type": "SEARCH", "value": "${search}" } }`,
      jobTitles: `${workforceurl}/dropdown/jobtitles?ret=title addedOn&lim=${limit} &fil={"title": {  "type": "SEARCH", "value": "${search}" } }`,
      atsJobTitles: `${atsurl}/dropdown/jobtitles?ret=title addedOn&lim=${
        300 + limit
      } &fil={"title": {  "type": "SEARCH", "value": "${search}" } }`,
      netTerms: `${workforceurl}/dropdown/netTerms?ret=title addedOn&lim=${limit} &fil={"title": {  "type": "SEARCH", "value": "${search}" } }`,
      deductions: `${workforceurl}/dropdown/deductions?ret=title addedOn&lim=${limit} &fil={"title": {  "type": "SEARCH", "value": "${search}" } }`,
      expensesTypes: `${workforceurl}/dropdown/expensesTypes?ret=title addedOn&lim=${limit} &fil={"title": {  "type": "SEARCH", "value": "${search}" } }`,
      jobRoles: `${workforceurl}/dropdown/jobRoles?ret=title addedOn&lim=${limit} &fil={"title": {  "type": "SEARCH", "value": "${search}" } }`,
      clientCategories: `${workforceurl}/dropdown/clientCategories?ret=title&lim=${limit}&fil={"title": {  "type": "SEARCH", "value": "${search}" } }`,
      jobTerminationNotices: `${workforceurl}/dropdown/jobTerminationNotices?ret=title&lim=${limit}&fil={"title": {  "type": "SEARCH", "value": "${search}" } }`,
      roleTypes: `${workforceurl}/dropdown/roleTypes?ret=title&lim=${limit}&fil={"title": {  "type": "SEARCH", "value": "${search}" } }`,
      placementsList: `${workforceurl}/dropdown/placementsList?ret=title&lim=${limit}&fil={"title": {  "type": "SEARCH", "value": "${search}" } }`,
      documentTypes: `${workforceurl}/dropdown/documenttypes?ret=title addedOn&lim=${limit} &fil={"title": {  "type": "SEARCH", "value": "${search}" } }`,
      contactTypes: `${workforceurl}/dropdown/contactTypes?ret=title&lim=${limit}&fil={"title": {  "type": "SEARCH", "value": "${search}" } }`,
      paymentMethods: `${workforceurl}/dropdown/paymentMethods?ret=title&lim=${limit}&fil={"title": {  "type": "SEARCH", "value": "${search}" } }`,
      depositTo: `${workforceurl}/dropdown/depositTo?ret=title&lim=${limit}&fil={"title": {  "type": "SEARCH", "value": "${search}" } }`,
      // financeManager: `${masterurl}/users/getAll?coll=User&fil={ "organizationId": {  "type": "NONE", "value": ${
      //   filter?.orgId ? filter.orgId : 0
      // } },"all": {  "type": "SEARCH", "value": "${search}"},role:{"type":"NONE","value":7 } }&ret=firstName%20lastName%20uiid&lim=${limit}`,
      financeManager: `${workforceurl}/employees/getAll?coll=Employee&fil={"all": { "type": "SEARCH", "value": "${search}"},"jobRole":{"type":"NONE","value":"FINANCE" } }&ret=firstName%20lastName%20uiid&lim=${limit}`,
      hiringManager: `${workforceurl}/employees/getAll?coll=Employee&fil={"all": { "type": "SEARCH", "value": "${search}"},"jobRole":{"type":"NONE","value":"HR" } }&ret=firstName%20lastName%20uiid&lim=${limit}`,
      immigrationManager: `${workforceurl}/employees/getAll?coll=Employee&fil={"all": { "type": "SEARCH", "value": "${search}"},"jobRole":{"type":"NONE","value":"IMMIGRATION" } }&ret=firstName%20lastName%20uiid&lim=${limit}`,
      //for role
      // financeManager: `${masterurl}/users/getAll?coll=User&fil={ "organizationId": {  "type": "NONE", "value": ${orgId} },"role": {  "type": "NONE", "value": 6 } }&ret=firstName%20lastName%20organizationId%20uiid&lim=${limit}`,
      // hiringManager: `${masterurl}/users/getAll?coll=User&fil={ "organizationId": {  "type": "NONE", "value": ${
      //   filter?.orgId ? filter.orgId : 0
      // } },"all": {  "type": "SEARCH", "value": "${search}" } }&ret=firstName%20lastName%20uiid&lim=${limit}`,
      // //countries: `${masterurl}/countries/getAll?coll=Country&ret=name&lim=${limit}`,
      // immigrationManager: `${masterurl}/users/getAll?coll=User&fil={ "organizationId": {  "type": "NONE", "value": ${
      //   filter?.orgId ? filter.orgId : 0
      // } },"all": {  "type": "SEARCH", "value": "${search}" } }&ret=firstName%20lastName%20uiid&lim=${limit}`,

      eVerifiedBy: `${masterurl}/users/getAll?coll=User&fil={ "organizationId": {  "type": "NONE", "value": ${
        filter?.orgId ? filter.orgId : 0
      } },"all": {  "type": "SEARCH", "value": "${search}" } }&ret=firstName%20lastName%20uiid&lim=${limit}`,

      countries: `${masterurl}/countries/getAll?coll=Country&ret=name&lim=${limit}&fil={ "name": { "type": "SEARCH", "value": "${search}" }}&cache=true`,

      countriesUsAndCanada: `${masterurl}/countries/getAll?coll=Country&ret=name iso2 iso3&lim=${limit}&fil={ "iso3": { "type": "IN", "value": ["USA","CAN","IND"] }, "name": { "type": "SEARCH", "value": "" } }&cache=true`,

      // states: `${masterurl}/states/getAll?coll=State&ret=name stateCode&lim=${limit}&pg=1&fil={ "name": { "type": "SEARCH", "value": "${search}" },"country":{"type":"NONE", "value": "${
      //   filter?.countrySearch ? filter.countrySearch : "" }"}}&cache=true`,
      states: `${masterurl}/states/getAll?coll=State&ret=name stateCode&lim=${limit}&pg=1&fil=${encodeURIComponent(JSON.stringify({ name: { type: "SEARCH", value: search }, ...(filter?.countrySearch && { country: { type: "NONE", value: filter.countrySearch } }) }))}&cache=true`,
      // cities: `${masterurl}/cities/getAll?coll=City&lim=${limit}&pg=1&fil={ "name": { "type": "SEARCH", "value": "${search}" },"country":{"type":"NONE", "value": "${filter?.countrySearch ?? ""}" },"stateName": ${JSON.stringify(stateFilter)} }&cache=true&errorHandler=true`,
      cities: `${masterurl}/cities/getAll?coll=City&lim=${limit}&pg=1&fil=${encodeURIComponent(JSON.stringify({ name: { type: "SEARCH", value: search }, ...(filter?.countrySearch && { country: { type: "NONE", value: filter.countrySearch } }), ...(filter?.stateSearch && { stateName: stateFilter }) }))}&cache=true`,
      citiesState: `${masterurl}/cities/getAll?coll=City&lim=${limit}&pg=1&fil={ "name": { "type": "SEARCH", "value": "${search}" } }&ref=Country&incl=name&cache=true&errorHandler=true`,
      atscitiesState: `${masterurl}/cities/getAll?coll=City&lim=${limit}&pg=1&fil={ "name": { "type": "CITY_STATE_SEARCH", "value": "${search}" } } &useAggregate=true&errorHandler=true`,
      allClientsList: `${workforceurl}/clients/getAll?coll=Client&lim=${limit}&fil={"businessName": { "type": "AG_BIND", "value": "${search}"}, "organizationId": {  "type": "NONE", "value": ${filter?.orgId ? filter.orgId : 0
        }}}&useAggregate=true`,

      allVendorsList: `${workforceurl}/vendors/getAll?coll=Vendor&lim=${limit}&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          ...(filter.entityId && {
            uiid: { type: "EXCLUDE", value: filter.entityId },
          }),
          // "uiid": { type: "EXCLUDE", value: filter.entityId },
        })
      )}&ret=businessName uiid &sort={"uiid":-1}`,
      allClientsSorted: `${workforceurl}/clients/getAll?coll=Client&lim=${limit}&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
        })
      )}&ret=businessName uiid placements shortCode jobCount &sort={"uiid":-1}`,
      clientsWithPlacements:
        `${workforceurl}/clients/getAll?coll=Client` +
        `&lim=${limit}` +
        `&fil=${encodeURIComponent(
          JSON.stringify({
            placements: {
              type: "AG_LOOKUP",
              value: {
                target: "type",
                value: filter.type,
                search: search,
              },
            },
          })
        )}` +
        `&ret=businessName uiid placements` +
        `&sort=${encodeURIComponent(JSON.stringify({ uiid: -1 }))}` +
        `&useAggregate=${filter?.useAggregate ?? false}`,

      employees: `${workforceurl}/employees/getAll?coll=Employee&lim=${limit}&pg=1&ret=jobTitle  firstName lastName uiid&fil={"all": {  "type": "SEARCH","value":"${search}"}}`,
      allEmployees: `${workforceurl}/employees/getAll?coll=Employee&lim=${limit}&pg=1&ret=${
        filter.ret
      }&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          ...filter.fil,
        })
      )}&useAggregate=${filter?.useAggregate ?? false}`,
      allEmployees4Type: `${workforceurl}/employees/getAll?coll=Employee&lim=${limit}&pg=1&ret=${
        filter.ret
      }&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          ...filter.fil,
        })
      )}&useAggregate=${filter?.useAggregate ?? false}&sort={"uiid":-1}`,
      employeeWithPlacement: `${workforceurl}/employees/getAll?coll=Employee&lim=${limit}&pg=1&ret=${
        filter.ret
      }&fil=${encodeURIComponent(
        JSON.stringify({
          placements: {
            type: "AG_LOOKUP",
            value: {
              target: "type",
              value: filter.type,
              search: search,
            },
          },
        })
      )}&useAggregate=${filter?.useAggregate ?? false}`,

      employeesSorted: `${workforceurl}/employees/getAll?coll=Employee&lim=${limit}&pg=1&ret=jobTitle firstName lastName employmentType uiid&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          classification: { type: "NONE", value: filter.classification || 1 },
        })
      )}&sort=${encodeURIComponent(JSON.stringify({ uiid: -1 }))}`,
      employeesSortedWithoutRef: `${workforceurl}/employees/getAll?coll=Employee&lim=${limit}&pg=1&ret=jobTitle firstName lastName employmentType uiid&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          classification: { type: "NONE", value: filter.classification || 1 },
          employmentType: { type: "IN", value: [1, 2, 3] },
        })
      )}&sort=${encodeURIComponent(JSON.stringify({ uiid: -1 }))}`,
      employeesSortedNonBillable: `${workforceurl}/employees/getAll?coll=Employee&lim=${limit}&pg=1&ret=jobTitle firstName lastName uiid&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          classification: { type: "NONE", value: filter.classification || 2 },
        })
      )}&sort=${encodeURIComponent(JSON.stringify({ uiid: -1 }))}`,

      employeesConsultantFullNames: `${workforceurl}/employees/getAll?coll=Employee&lim=${limit}&pg=1&ret=jobTitle  firstName lastName uiid employmentType&fil={"all": {  "type": "SEARCH","value":"${search}"}}&sort={"uiid":-1}`,
      employeeClients: `${workforceurl}/employees/getAll?coll=Employee&lim=${limit}&pg=1&fil={"firstName": {  "type": "SEARCH", "value": "${search}" } }&cache=false&ret=${filter?.ret}&ref=${filter?.ref}`,
      employeePlacements: `${workforceurl}/employees/getAll?coll=Employee&lim=${limit}&pg=1&ret=${filter.ret}&ref=${filter.ref}&fil=${filParam}&cache=false`,

      //if want employees as conultant type 👇👇
      // employeesConsultant: `${workforceurl}/employees/getAll?coll=Employee&lim=${limit}&pg=1&ret=jobTitle  firstName lastName uiid&fil={"all": {  "type": "SEARCH","value":"${search}"},"employmentType":{"type":"NONE","value":2}}`,
      clientPlacements: `${workforceurl}/placements/getAll?coll=Placement&lim=${limit}&ref=Employee Client Vendor&incl=uiid firstName middleName lastName businessName&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          "jobInfo.billClient": filter?.entityId
            ? { type: "NONE", value: filter?.entityId }
            : undefined,
          // "jobInfo.entityType": {
          //   type: "NONE",
          //   value: filter?.entityType ?? 0,
          // },
        })
      )}&ret=jobInfo.jobCode jobInfo.jobTitle uiid employmentType employeeId entityId jobInfo.entityType`,
      vendorPlacements: `${workforceurl}/placements/getAll?coll=Placement&lim=${limit}&ref=Employee Client Vendor&incl=uiid firstName middleName lastName businessName&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          "vendor.id": filter?.entityId
            ? { type: "NONE", value: filter?.entityId }
            : undefined,
          // "jobInfo.entityType": {
          //   type: "NONE",
          //   value: filter?.entityType ?? 0,
          // },
        })
      )}&ret=jobInfo.jobCode jobInfo.jobTitle vendor uiid employmentType employeeId entityId jobInfo.entityType`,

      placementsWithEmployeeName: `${workforceurl}/placements/getAll?coll=Placement&lim=50&useAggregate=true&fil=${encodeURIComponent(
        JSON.stringify({
          vendorId: {
            type: "AG_VENDOR_REF",
            value: [filter?.entityId, search],
          },
          // all: { type: "SEARCH", value: search },
          // "vendor.id": filter?.entityId
          //   ? { type: "NONE", value: filter?.entityId }
          //   : undefined,
          // "jobInfo.entityType": {
          //   type: "NONE",
          //   value: filter?.entityType ?? 0,
          // },
        })
      )}`,
      placementsForPayConfigDropDown: `${workforceurl}/placements/getAll?coll=Placement&lim=50&ret=clientPlacement uiid&fil=${encodeURIComponent(
        JSON.stringify({
          employeeId: {
            type: "NONE",
            value: filter?.entityId,
          },
          // ...(filter?.entityType && {
          //   "clientPlacement.placement": {
          //     type: "EXCLUDE",
          //     value: "P1",
          //   },
          // }),
        })
      )}`,

      //can have filters for a specific delegators placements only 👇👇
      placementsForTimesheetsAdd: `${workforceurl}/placements/getAll?coll=Placement&lim=${limit}&incl=firstName middleName lastName employmentType businessName&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          employeeId: filter?.employeeId
            ? { type: "NONE", value: filter?.employeeId }
            : undefined,
          // entityId: { type: "NONE", value: filter?.entityId ?? 0 },
          // "jobInfo.entityType": {
          //   type: "NONE",
          //   value: filter?.entityType ?? 0,
          // },
          "jobInfo.status": {
            type: "NONE",
            value: 1,
          },
        })
      )}&ret=jobInfo.jobCode jobInfo.jobTitle jobInfo.billClient  uiid  employeeId&ref=Client Employee`,
      allPayProfiles: `${workforceurl}/salaryprofiles/getAll?coll=SalaryProfile&ret=name payCycle uiid status&lim=${limit}&fil=${encodeURIComponent(
        JSON.stringify({
          ...(search?.trim() && { name: { type: "SEARCH", value: search } }),
          status: { type: "NONE", value: 1 },
        })
      )}`,
      allTimesheetClients: `${workforceurl}/timesheets/getAll?coll=Timesheet&useAggregate=true&lim=${limit}&fil=${encodeURIComponent(
        JSON.stringify({
          timesheets: {
            type: "AG_SEARCH",
            value: [filter?.employeeId, search || ""],
          },
        })
      )}`,
      allInvoiceClients: `${workforceurl}/invoices/getAll?coll=Invoice&useAggregate=true&lim=${limit}&fil=${encodeURIComponent(
        JSON.stringify({
          invoices: {
            type: "AG_SEARCH",
            value: [filter?.employeeId, search || ""],
          },
        })
      )}`,

      //Onboarding Dropdowns
      //Onboarding Dropdowns
      //Onboarding Dropdowns
      employeesSortedOnboarding: `${workforceurl}/employees/getAll?coll=Employee&lim=${limit}&pg=1&ret=jobTitle firstName lastName employmentType uiid&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          classification: { type: "NONE", value: filter.classification || 1 },
          onboardId: { type: "EXISTS", value: false },
        })
      )}&sort=${encodeURIComponent(JSON.stringify({ uiid: -1 }))}`,
      clientsSortedOnboarding: `${workforceurl}/clients/getAll?coll=Client&lim=${limit}&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          // onboardId:{type:"EXISTS",value:false},
        })
      )}&ret=businessName uiid placements shortCode jobCount &sort={"uiid":-1}`,
      allVendorsListOnboarding: `${workforceurl}/vendors/getAll?coll=Vendor&lim=${limit}&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          // onboardId:{type:"EXISTS",value:false},
          ...(filter.entityId && {
            uiid: { type: "EXCLUDE", value: filter.entityId },
          }),
          // "uiid": { type: "EXCLUDE", value: filter.entityId },
        })
      )}&ret=businessName uiid &sort={"uiid":-1}`,
      allPdfTemplatesNames: `${workforceurl}/pdftemplates/getAll?coll=PdfTemplate&lim=${limit}
      &fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          category: {
            type: "NONE",
            value: filter?.category ? filter?.category : "",
          },
        })
      )}
      &ret=name uiid templateId category type &sort={"uiid":-1}`,
      usersForEonboarding: `${workforceurl}/employees/getAll?coll=Employee&lim=${limit}&pg=1&ret=jobTitle firstName lastName uiid userId&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          classification: { type: "NONE", value: filter.classification || 2 },
        })
      )}&sort=${encodeURIComponent(JSON.stringify({ uiid: -1 }))}`,
      checklistsWithEntityFilter: `${workforceurl}/checklists/getAll?coll=Checklist&lim=${limit}&pg=1&ret=uiid name entity documents&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          ...(filter?.entityFilter && {
            entity: { type: "NONE", value: filter?.entityFilter },
          }),
        })
      )}&ref=DocumentWithInitator&sort=${encodeURIComponent(
        JSON.stringify({ uiid: -1 })
      )}`,

      // ats
      // ats
      // ats
      // ats
      // ats
      industry: `${atsurl}/dropdown/industry?ret=title addedOn&lim=${limit} &fil={"title": {  "type": "SEARCH", "value": "${search}" } }`,
      atsRoles: `${masterurl}/roles/getAll?coll=Role&ret=name module type uiid&fil={"module": {"type": "NONE", "value": 2},"name":{"type": "SEARCH", "value": "${search}"}}&lim=${filter?.condition ?? limit}`,
      //benchsales options
      UserRef: `${benchsalesurl}/userrefs/getAll?coll=UserRef&lim=${limit}&useAggregate=true&fil=${encodeURIComponent(
        JSON.stringify({
          ...(search?.trim()?.length > 0 && {
            all: { type: "SEARCH", value: search.trim() },
          }),

          recruiterDropdown: {
            type: "BS_RECRUITER_DROPDOWN",
            value: [],
          },

          ...(filter?.role && {
            role: filter.role,
          }),

          ...(filter?.usage && {
            usage: filter.usage,
          }),
          ...(filter?.uiid && {
            uiid: filter.uiid,
          }),
        })
      )}`,
      Jobs: `${benchsalesurl}/candidates/getAll?coll=Candidate&lim=${limit}&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          ...(filter?.assignedBy && {
            assignedBy: { type: "NONE", value: filter.assignedBy },
          }),
        })
        // )}&ret=firstName lastName uiid preferences`,
      )}&ret=firstName lastName uiid preferences email mobileNumber experiences city state country`,

      Candidate: `${benchsalesurl}/candidates/getAll?coll=Candidate&lim=${limit}&useAggregate=true&fil=${encodeURIComponent(
        JSON.stringify({
          ...(search?.trim()?.length > 0 && {
            all: { type: "SEARCH", value: search.trim() },
          }),

          candidateDropdown: {
            type: "BS_CANDIDATE_DROPDOWN",
            value: [],
          },

         
          ...(filter?.assignedBy && {
            assignedBy: filter.assignedBy,
          }),
        })
      )}`,

      //   Company: `${benchsalesurl}/companys/getAll?coll=Company&lim=${limit}&ret=companyName`,
      bs_company_name: `${benchsalesurl}/companys/getAll?coll=Company&lim=${limit}&fil=${encodeURIComponent(
        JSON.stringify({
          companyName: { type: "SEARCH", value: search },
        })
      )}&ret=companyName uiid`,

      Submission: `${benchsalesurl}/submissions/getAll?coll=Submission&lim=${limit}&useAggregate=true&ref=Candidate Job Contact&fil=${encodeURIComponent(
        JSON.stringify({
          ...(search?.trim()?.length > 0 && {
            all: { type: "SEARCH", value: search.trim() },
          }),

          submissionDropdown: {
            type: "BS_SUBMISSION_DROPDOWN",
            value: [],
          },

          ...(filter?.addedBy && {
            addedBy: filter.addedBy,
          }),
        })
      )}&ret=candidateId`,
      Interview: `${benchsalesurl}/interviews/getAll?coll=Interview&lim=${limit}&useAggregate=true&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          submissionDropdown: {
            type: "BS_INTERVIEW_DROPDOWN",
            value: [],
          },
          ...(filter?.addedBy && {
            addedBy: filter.addedBy,
          }),
        })
      )}&ret=candidateId`,
      Placement: `${benchsalesurl}/interviews/getAll?coll=Interview&lim=${limit}&useAggregate=true&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          ...(filter?.interviewDetails && {
            placementDropdown: {
              type: "BS_INTERVIEW_ROUND5_PLACEMENT_DROPDOWN",
              value: [],
            },
          }),
          ...(filter?.addedBy && {
            addedBy: filter.addedBy,
          }),
        })
      )}&ret=candidateId`,

      Contact: `${benchsalesurl}/contacts/getAll?coll=Contact&lim=${limit}&fil=${encodeURIComponent(
        JSON.stringify({
          all: { type: "SEARCH", value: search },
          ...(filter?.companyId && {
            companyId: { type: "NONE", value: filter.companyId },
          }),
        })
      )}`,
      // bs_email_templates: `${benchsalesurl}/templates/getAll?coll=Template&lim=${limit}&fil=${encodeURIComponent(
      //   JSON.stringify({
      //     entity: {
      //       type: "NONE",
      //       value: 1,
      //     },
      //   })
      // )}`,
      bs_email_templates: `${benchsalesurl}/templates/getAll?coll=Template&lim=${limit}&fil=${encodeURIComponent(
  JSON.stringify({
    entity: {
      type: "NONE",
      value: 1,
    },
    ...(filter?.category && {
      category: {
        type: "NONE",
        value: filter.category,
      },
    }),
  })
)}`,
      bs_candidate_email_templates: `${benchsalesurl}/templates/getAll?coll=Template&lim=${limit}&fil=${encodeURIComponent(
        JSON.stringify({
          entity: {
            type: "NONE",
            value: 2,
          },
        })
      )}`,

      benchsalesRoles: `${masterurl}/roles/getAll?coll=Role&ret=name module type uiid&fil={"module": {"type": "NONE", "value": 4}}&lim=${limit}`,
      workforceRoles: `${masterurl}/roles/getAll?coll=Role&ret=name module type uiid&fil={"module": {"type": "NONE", "value": 3}}&lim=${limit}`,
      users: `${masterurl}/users/getAll?coll=User&lim=${limit}&pg=1&ret=uiid firstName lastName&fil={"organizationId":{"type": "NONE", "value": ${orgId}},"firstName": { "type": "SEARCH", "value": "${search}"}}`,
      bdmManagers: `${masterurl}/users/getAll?coll=User&lim=${limit}&pg=1&ret=uiid firstName lastName&fil={"role":{"type": "NONE", "value":[3]},"level":{"type": "NONE", "value":[5]},"organizationId":{"type": "NONE", "value": ${orgId}}}`,
      bdmUsers: `${atsurl}/userrefs/getAll?lim=${limit}&pg=1&ret=uiid firstName lastName&fil={"role.type":{"type": "IN", "value":[1,3,4]},"status":{"type":"NONE","value":1},"firstName": { "type": "SEARCH", "value": "${search}"}}`,
      bdmAndRecruiters: `${masterurl}/users/getAll?coll=User&lim=${limit}&pg=1&ret=uiid firstName lastName&fil={"role":{"type": "NONE", "value":[1,3,4]},"level":{"type": "NONE", "value":[5]},"organizationId":{"type": "NONE", "value": ${orgId}}}`, // use this for BDM and recruiters manager's users list
      bdmAndRecruitersUsers: `${atsurl}/userrefs/getAll?lim=${limit}&pg=1&ret=uiid firstName lastName&fil={"role.type":{"type": "IN", "value":[1,3,4]},"status":{"type":"NONE","value":1},"firstName": { "type": "SEARCH", "value": "${search}"}}`, // use this for BDM and recruiters all users list in userrefs
      AllBdmRecruiters: `${atsurl}/userrefs/getAll?lim=${limit}&pg=1&ret=uiid firstName lastName&fil={"role.type":{"type": "IN", "value":[1,3,4]},"status":{"type":"NONE","value":1},"firstName": { "type": "SEARCH", "value": "${search}"}}`,
      // emailSourceAccounts: `${atsurl}/integrationaccesss/getAll?coll=IntegrationAccess&lim=${limit}&pg=1&ret=uiid userId accessConfig integration.uiid&useAggregate=true&fil={"integration": {"type": "AG_INTERACTIONS_ACCESS_TO_INTEGRATION","value": [{"category": ${filter?.category}}, {"type": ${filter?.type}}],"userId":${filter?.userId}}}`,
      emailSourceAccounts: `${atsurl}/integrationaccesss/getAll?coll=IntegrationAccess&lim=${limit}&pg=1&ret=uiid userId accessConfig integration.uiid&useAggregate=true&fil={"integration": {"type": "AG_INTERACTIONS_ACCESS_TO_INTEGRATION","value": [{"category": ${filter?.category
        }}, {"type": ${filter?.type}}]${filter?.userId ? `,"userId":${filter?.userId}` : ""
        }}}`,
      // emailSourceAccountsBs: `${benchsalesurl}/integrationaccesss/getAll?coll=Integrationaccess&lim=${limit}&pg=1&ret=uiid userId accessConfig integration.uiid&useAggregate=true&fil={"integration": {"type": "AG_INTERACTIONS_ACCESS_TO_INTEGRATION","value": [{"category": ${filter?.category}}, {"type": ${filter?.type}}, {"status": 1}]${filter?.userId ? `,"userId":${filter?.userId}` : ""}}}`,
      // emailSourceAccountsBs: `${benchsalesurl}/emailaccounts/getAll?coll=EmailAccount&lim=${limit}&pg=1&ret=uiid&useAggregate=true&fil={"emailaccount":{"type":"AG_GET_ACCESSED_MAIL","value":[{"provider":${filter.type}},"userId":${filter.userId}]}}`, 
// emailSourceAccountOauthBs: `${benchsalesurl}/emailaccounts/getAll?coll=EmailAccount&lim=${limit}&pg=1&ret=uiid&useAggregate=true&fil=${filter}`,

emailSourceAccountsBs: `${benchsalesurl}/emailaccounts/getAll?coll=EmailAccount&lim=${limit}&pg=1&ret=uiid&useAggregate=true&fil=${encodeURIComponent(
  JSON.stringify({
    emailaccount: {
      type: filter.aggr,
      value:filter.userId,
      provider:filter.type,
    },  
  })  
)}`,  
    // templates: `${atsurl}/templates/getAll?coll=Template&lim=${limit}&pg=1&ret=uiid title body subject&fil={"title": { "type": "SEARCH", "value": "${search}" },"assignedTo":{"type":"NONE","value":"${filter?.userId}"} }`,
      templates: `${atsurl}/templates/getAll?coll=Template&lim=${limit}&pg=1&ret=uiid title body subject&fil=${encodeURIComponent(
        JSON.stringify({
          title: { type: "SEARCH", value: search },
          ...(filter?.userId && {
            assignedTo: { type: "NONE", value: filter.userId },
          }),
        })
      )}`,

      AllRecruiters: `${benchsalesurl}/userrefs/getAll?coll=UserRef&fil={"role.module":{"type": "IN", "value":[4]},"role.type":{"type": "IN", "value":[3,9]},"firstName": { "type": "SEARCH", "value": "${search}" }}&ret=uiid firstName lastName&lim=${limit}&pg=1`,
      getCampaignAccounts: `${atsurl}/integration/instaly-getAllAccounts?lim=${limit}&accessId=${
        filter?.campaignsAccessId
      }&search=${search}${
        filter.starting_afteracc
          ? `&starting_afteracc=${filter.starting_afteracc}`
          : ""
      }${
        filter.starting_aftertag
          ? `&starting_aftertag=${filter.starting_aftertag}`
          : ""
      }`,
      getWorkSpaceUsers:`${atsurl}/integration/instantly-workspace-users?lim=${limit}&accessId=${filter?.campaignsAccessId}`,
      allCompanies: `${atsurl}/companys/getAll?lim=${limit}&pg=1&ret=uiid name&coll=Company&fil={"name": { "type": "SEARCH", "value": "${search}" } }`,
      companiesSearch: `${atsurl}/jobpostings/getAll?coll=JobPosting&ref=Submission&fil={ "value": {  "type": "JOBS_COMPANIES_SEARCH", "value": "${search}" } }&useAggregate=true&pg=1&lim=${limit}`,

      //allUsers: `${atsurl}/userrefs/getAll?lim=${limit}&pg=1&coll=UserRef&ret=uiid firstName lastName`,
      // getJobBoardUsers: `${atsurl}/userrefs/getAll?fil={"role.type":{"type": "IN", "value": [1, 3, 4]},"firstName":{"type":"MUTLI_FEILD_SEARCH","value":"${search.trim().split(" ")[0]}"},"lastName":{"type":"MUTLI_FEILD_SEARCH","value":"${search.trim().split(" ")[1] ? search.trim().split(" ")[1] : search.trim().split(" ")[0]}"}}&lim=${limit}&pg=1&ret=uiid firstName lastName`,

      allUsers: `${atsurl}/userrefs/getRepotingHierarchy?fil={"value": {  "type": "SORTING_DATA", "value": "[${filter?.uiids}]**${search}"}}&lim=${limit}&coll=UserRef&ret=uiid firstName lastName`,
      // getJobBoardUsers: `${atsurl}/userrefs/getAll?fil={"role.type":{"type": "IN", "value": [1, 3, 4]},"status":{"type":"NONE","value":1},"firstName":{"type":"SEARCH","value":"${search}"}}&lim=${limit}&pg=1&ret=uiid firstName lastName`,
      getJobBoardUsers: `${atsurl}/userrefs/getAll?fil={"uiid":{"type": "AG_JOBBOARD_USERS", "value": "${search}"}}&lim=${limit}&ret=uiid firstName lastName`,
      aiCallAssistants: `${atsurl}/integrations/getAll?coll=Integration&lim=${limit}&pg=1&fil={"status": {"type":"NONE", "value": 1}, "category": {"type": "NONE", "value": 6}, "type": {"type": "NONE", "value": 2} }`,
      onlyBDMUsers: `${atsurl}/userrefs/getAll?fil={"role.type":{"type": "NONE", "value": 3},"firstName":{"type":"SEARCH","value":"${search}"}}&lim=${limit}&pg=1&ret=uiid firstName lastName`,
      getJobBoardUsersBs: `${benchsalesurl}/userrefs/getAll?fil={"uiid":{"type": "AG_JOBBOARD_USERS_BS", "value": "${search}"}}&lim=${limit}&ret=uiid firstName lastName email`,
      getCandidateAuthEmailsBs: `${benchsalesurl}/candidates/getAll?coll=Candidate&lim=${limit}&pg=1&ret=uiid email firstName middleName lastName&fil={"name": { "type": "SEARCH", "value": "${search}" } }`
    };

    const mappingConfig = (type) => (item) => {
      switch (type) {
        case "jobTitles":
        case "netTerms":
        case "jobRoles":
        case "deductions":
        case "expensesTypes":
        case "clientCategories":
        case "jobTerminationNotices":
        case "documentTypes":
        case "contactTypes":
        case "roleTypes":
        case "placementsList":
        case "paymentMethods":
        case "depositTo":
          return {
            label: item.title,
            value: item.title,
          };
        case "industry":
        case "atsJobTitles":
          return {
            label: formatWords2(item.title),
            value: item.title,
          };
        case "atsRoles":
          return {
            label: item.name,
            value: item.uiid,
            type: item.type,
            id: item._id,
          };
        case "benchsalesRoles":
          return {
            label: item.name,
            value: item.uiid,
            type: item.type,
            id: item._id,
          };
        case "workforceRoles":
          return {
            label: item.name,
            value: item.uiid,
          };
        case "users":
        case "bdmAndRecruiters":

        case "AllBdmRecruiters":
        case "bdmManagers":
        case "bdmUsers":
        case "AllRecruiters":
        case "onlyBDMUsers":
          return {
            label: `${item.firstName} ${item.lastName}`,
            value: item.uiid,
          };
        case "bdmAndRecruitersUsers":
          return {
            label: `${item.firstName} ${item.lastName}`,
            value: `${item.firstName} ${item.lastName}-${item.uiid}`,
          };
        case "financeManager":
        case "hiringManager":
        case "immigrationManager":
        case "eVerifiedBy":
          return {
            label: item.firstName + " " + item.lastName,
            value: item.uiid,
          };
        case "countries":
        case "countriesUsAndCanada":
        case "states":
        case "cities":
          return {
            label: item.name,
            value: item.name,
            id: item?._id,
            code: item?.iso2 ?? item?.stateCode ?? "",
          };
        case "allPdfTemplatesNames":
          return {
            label: item.name,
            value: item.uiid,
            id: item?._id,
            data: item,
          };
        case "atscitiesState":
          return {
            label: item.name + " - " + item?.stateName,
            value: item.name + " - " + item?.stateName,
          };
        case "allCompanies":
          return {
            label: item.name,
            value: item.uiid,
          };
        case "allUsers":
          return {
            label: item.firstName + " " + item.lastName,
            value: item.uiid,
          };
        case "getJobBoardUsers":
          return {
            label: item.firstName + " " + item.lastName,
            value: item.uiid,
          };
        case "getJobBoardUsersBs":
          return {
            label: item.firstName + " " + item.lastName,
            value: item.uiid,
          };
        case "getCandidateAuthEmailsBs":
          return {
            label: item.firstName + " " + item.lastName,
            value: item.uiid,
            email: item.email,
          };
        case "companiesSearch":
          return {
            label: `${item?.jobInfo?.jobCode}-${item?.job?.title}-${item?.company?.name}`,
            value: item.uiid,
            uiid: item.uiid,
          };
        //       case "atscitiesState":
        // return [
        //   {
        //     label: item.name + " - " + item?.stateName, // City - State
        //     value: item.name + " - " + item?.stateName,
        //     type: "city",
        //   },
        //   {
        //     label: item?.stateName, // Only State
        //     value: item?.stateName,
        //     type: "state",
        //   }
        // ];

        case "citiesState":
          return {
            label: item.name + " - " + item?.stateName,
            value: item.name + " - " + item?.stateName,
          };
        case "employeeClients": {
          const placements = item?.placements || [];
          return placements.map((item2) => ({
            label:
              item.firstName + " - " + item2?.jobInfo?.billClient?.businessName,
            value:
              item.firstName +
              " - " +
              item2?.jobInfo?.billClient?.businessName +
              "-" +
              item2.uiid,
            clientId: item2?.jobInfo?.billClient?.uiid,
            uiid: item.uiid,
          }));
        }
        case "employeePlacements": {
          const placements = item?.placements || [];
          const placementUiids = filter?.placementUiid || [];
          const filteredData = placements.filter((placement) =>
            placementUiids.includes(placement?.uiid)
          );
          return filteredData.map((placement) => ({
            label: `${item.firstName} - ${
              placement?.jobInfo?.billClient?.businessName || ""
            }`,
            value: `${item.firstName} - ${
              placement?.jobInfo?.billClient?.businessName || ""
            }-${placement.uiid}`,
            uiid: item.uiid,
          }));
        }
        case "allEmployees": {
          const placements =
            filter?.selectedClientWithPlacements?.placements || [];
          // if (!filter?.selectedClientWithPlacements?.placements) {
          return placements
            .map((placement) => {
              if (placement && placement.employeeId === item.uiid) {
                return {
                  label: `${item.firstName} - ${
                    placement?.clientId?.businessName || ""
                  } - ${placement?.jobTitle}`,
                  value: `${item.firstName} - ${
                    placement?.clientId?.businessName || ""
                  } - ${placement?.jobTitle} -${item?.uiid}`,
                  uiid: item.uiid,
                  placementId: placement?.uiid,
                };
              }
              return null;
            })
            .filter(Boolean); // Remove nulls
          // } else {
          //   return {
          //     label: item?.firstName,
          //     value: item?.uiid,
          //     coll: item?.coll,
          //   };
          // }
        }

        case "employeeWithPlacement":
          const placements = item?.placements || [];
          return placements.map((placement) => ({
            label: `${item.firstName} - ${
              placement?.clientId?.businessName || ""
            }`,
            value: `${item.firstName} - ${
              placement?.clientId?.businessName || ""
            }-${placement.uiid}`,
            uiid: item.uiid,
            placementId: placement?.uiid,
            clientId: placement?.clientId?.uiid,
            businessName: placement?.clientId?.businessName,
          }));
        case "allClientsList":
          return {
            label: item.businessName,
            value: item.uiid,
            coll: item.coll,
          };
        case "allVendorsList":
        case "allVendorsListOnboarding":
          return {
            label: item.businessName + " | " + `VEN-${item.uiid}`,
            value: item.uiid,
          };
        case "allClientsSorted":
        case "clientsSortedOnboarding":
          if (filter?.showNames) {
            return {
              label: item.businessName,
              value: item.uiid,
            };
          } else {
            return {
              label: item.businessName + " | " + `CLI-${item.uiid}`,
              value: item.uiid,
            };
          }
        case "clientsWithPlacements":
          return {
            label: item.businessName,
            value: item.uiid,
          };
        case "employees":
          // return {
          //   label: item.jobTitle + " - " + item.firstName + " " + item.lastName,
          //   value: item.uiid,
          // };
          return {
            label: item.firstName + " - " + item.jobTitle,
            value: item.uiid,
          };
        case "employeesSorted":
        case "employeesSortedNonBillable":
        case "employeesSortedWithoutRef":
        case "allEmployees4Type":
        case "employeesSortedOnboarding":
          // return {
          //   label: item.jobTitle + " - " + item.firstName + " " + item.lastName,
          //   value: item.uiid,
          // };
          return {
            label:
              item.firstName +
              " " +
              item.lastName +
              "  " +
              `(${getEmployeeId(item.uiid, item.employmentType)})`,
            value: item.uiid,
          };
        case "usersForEonboarding": {
          return {
            label:
              item.firstName +
              " " +
              item.lastName +
              "  " +
              `(${getEmployeeId(item.uiid, item.employmentType)})`,
            value: item?.userId,
          };
        }
        case "employeesConsultantFullNames":
          return {
            label:
              item?.firstName +
              " " +
              item?.lastName +
              " | " +
              getEmployeeId(item?.uiid, item.employmentType),
            value: item?.uiid,
          };
        case "placements":
        case "placementsForTimesheetsAdd":
        case "vendorPlacements":
        case "clientPlacements":
          return {
            label:
              `${item?.jobInfo?.jobTitle} at ${
                item?.jobInfo?.billClient?.businessName
              } | ${getShortBusinessName(
                item?.jobInfo?.billClient?.businessName
              )}-${item?.uiid}` || "",
            value: item?.uiid + ":" + item?.jobInfo?.billClient?.uiid,
            // value: item?.uiid,
          };
        case "placementsWithEmployeeName":
          return {
            label:
              item.employeeId?.firstName +
                " " +
                item?.employeeId?.lastName +
                " | " +
                `(${getEmployeeId(
                  item.employeeId.uiid,
                  item.employeeId.employmentType
                )})` || "",
            value: item?.employeeId?.uiid,
            placementId: item?.uiid,
            payments: item?.payments,
            source: item?.source,
            lastPay: item?.lastPay,
            // value: item?.uiid,
          };
        case "placementsForPayConfigDropDown":
          return {
            label: item.clientPlacement?.placement || "-",
            value: item?.uiid,
          };
        case "allPayProfiles": {
          const cycle = SalaryProfileCycles.find(
            (data) => item.payCycle === data.value
          );
          return {
            label: `${item?.name}${cycle ? ` (${cycle.label})` : ""}`,
            value: item?.uiid,
            payCycle: item?.payCycle,
          };
        }
        case "allTimesheetClients":
        case "allInvoiceClients": {
          return {
            label: `${item?.name}`,
            value: item?.uiid,
          };
        }
        case "emailSourceAccounts": {
          return item?.accessConfig?.emails
            ? item?.accessConfig?.emails.map((email) => ({
                label: email,
                value: `${email}-${item?.uiid}`,
                integrationId: item?.integration?.uiid,
                userId: item?.userId,
                accessUiid: item?.uiid,
              }))
            : []; // Return an empty array if email is not present
        }
          // case "emailSourceAccountsBs": {
          //   return item?.accessConfig?.emails
          //     ? item?.accessConfig?.emails.map((email) => ({
          //       label: email,
          //       email: email,
          //       value: `${email}-${item?.uiid}`,
          //       integrationId: item?.integration?.uiid,
          //       userId: item?.userId,
          //       accessUiid: item?.uiid,
          //     }))
          //     : []; // Return an empty array if email is not present
          // } 


          case "emailSourceAccountsBs": {
  const email = item?.email;
  if (!email) return [];
  return [{
    label: email,
    email: email,
    _id: item?._id,  
    value: `${email}-${item?._id}`,
    userId: item?._id,
    accessUiid: item?._id,
  }];
}
        case "emailSourceAccountOauthBs":{
          return item.email

        }
        case "candidateAuthEmails": {
          return  {
            label: item?.accessConfig?.email||"" ,
            accessUiid: item?.uiid,
            value: `${item?.accessConfig?.email}-${item?.uiid}`,
          }
        }
        case "templates":
          return {
            label: item?.title,
            value: item?.uiid,
            body: item?.body,
            subject: item?.subject,
          };
        case "Candidate":
          return {
            label: item.label,
            value: item.uiid,
            uiid: item.uiid,
            data: item,
          };
        case "Jobs":
          return {
            label: `${item.firstName} ${item.lastName}`,
            value: item.uiid,
            uiid: item.uiid,
            data: item,
          };
        case "bs_company_name":
          return {
            label: `${item.companyName}`,
            // value: item.uiid,
            value: item.companyName,
            uiid: item.uiid,
            data: item,
          };
        case "UserRef":
          return {
            label: item.label,
            value: item.value,
            uiid: item.value,
            data: item,
          };
        case "Contact":
          return {
            label: `${item.firstName} ${item.lastName}`.trim(),
            firstName: item.firstName,
            lastName: item.lastName,
            email: item.email,
            designation: item.designation,
            location: item.location,
            _id: item._id,
            isInternallyVerified: item?.isInternallyVerified,
            isValidEmailVerified: item?.isValidEmailVerified,
            uiid: item?.uiid
          };

        case "Submission":
          return {
            label: item.label,
            value: item.uiid,
            uiid: item.uiid,
            data: item,
          };
        // case "Placement":
        //   return {
        //     label: `${item.candidateId.firstName} ${item.candidateId.lastName}`,
        //     value: item.candidateId.uiid,
        //     uiid: item.candidateId.uiid,
        //     data: item,
        //   };
        // new dropdownoptions added for placements long with filter in db
        case "Placement":
          return {
            label: item.label,
            value: item.value,
            uiid: item.value,
            data: item,
          };
        // case "Interview":
        //   return {
        //     label: `${item.candidateId.firstName} ${item.candidateId.lastName}`,
        //     value: item.candidateId.uiid,
        //     uiid: item.candidateId.uiid,
        //     data: item,
        //   };

        case "Interview":
          return {
            label: item.label,
            value: item.value,
            uiid: item.value,
            data: item,
          };
        case "getCampaignAccounts":
          return item?.items
            ? item.items.map((acc) => ({
                label: acc?.email || acc?.label,
                value: acc?.email
                  ? `${acc.email}-${acc?.organization}`
                  : acc?.id,
                type: acc?.email ? "acc" : "tag",
                organization_id: acc?.email
                  ? acc?.organization
                  : acc?.organization_id,
                next_starting_after: item?.next_starting_after,
              }))
            : [];
            case "getWorkSpaceUsers":
              return{
                label: item?.name?.first || "",
                value: item?.user_id || "",
                data: item,
              };
        case "checklistsWithEntityFilter":
          return {
            label: item?.name || "",
            value: item?.uiid || "",
            metaData: item,
          };
        case "bs_email_templates":
          return {
            label: item?.name || "",
            value: item?._id || "",
            metaData: item,
          };
        case "bs_candidate_email_templates":
          return {
            label: item?.name || "",
            value: item?._id || "",
            metaData: item,
          };

        // case "placements":
        //   return {
        //     label:
        //       item?.jobInfo?.jobCode +
        //       " - " +
        //       item?.jobInfo?.jobTitle +
        //       " " +
        //       item?.employeeId?.firstName +
        //       " - " +
        //       item.employeeId.lastName,
        //     value: item?.employeeId?.uiid,
        //   };
        case "aiCallAssistants":
          return {
            label: item.name,
            value: item.uiid,
            id: item._id,
          };
        default:
          return null;
      }
    };

    const endpoint = endpointMap[type];
    // const mapper = mappingConfig[type];
    const mapper = mappingConfig(type);
    if (!endpoint || !mapper) {
      throw new Error(
        `No endpoint or mapping defined for dropdown type: ${type}`
      );
    }

    const token = localStorage.getItem("token");

    // const response = await axios.get(endpoint, {
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //     "Content-Type": "application/json",
    //   },
    //   withCredentials: true,
    // });
    const response = await axiosRequest({
      method: "GET",
      url: endpoint,
    });
    const result = response?.data?.data || [];
    const filterData = Array.isArray(result) ? result.map(mapper) : [];
    const flattenTypes = [
      "employeeClients",
      "employeePlacements",
      "allEmployees",
      "employeeWithPlacement",
      "emailSourceAccounts",
      "getCampaignAccounts",
      "emailSourceAccountsBs",
      "emailSourceAccountOauthBs",
    ];
    const formattedResult = flattenTypes.includes(type)
      ? filterData.flat()
      : filterData;

    if (type === "atscitiesState") {
      // Get unique state options in label/value format
      const uniqueStateOptions = [
        ...new Set(result.map((item) => item.stateName)),
      ].map((state) => ({
        label: state,
        value: state,
      }));

      // Append uniqueStateOptions to formattedResult
      return {
        formattedResult: [...uniqueStateOptions, ...formattedResult],
        result,
      };
    }
    if (type === "atsJobTitles") {
      formattedResult.sort((a, b) => {
        const searchText = search.toLowerCase().trim();
        const aLabel = a.label.toLowerCase();
        const bLabel = b.label.toLowerCase();

        if (aLabel === searchText && bLabel !== searchText) return -1;
        if (bLabel === searchText && aLabel !== searchText) return 1;

        if (aLabel.startsWith(searchText) && !bLabel.startsWith(searchText))
          return -1;
        if (bLabel.startsWith(searchText) && !aLabel.startsWith(searchText))
          return 1;

        return 0;
      });
    }
    return { formattedResult, result };
  } catch (error) {
    console.error(`dropDownGetter error for ${type}:`, error);
    return [];
  }
};
